import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

export const placesZoom = 7.2;
export const REGION_TAG = 'dt';
export const BASE_URL = 'https://places.api.upoui.com/';
export const LOCATIONIQ_BASE_URL = 'https://us1.locationiq.com/v1/search?key=';
export const PLACES_API = BASE_URL + `places?tags_filter=${REGION_TAG}`;
export const Cities_API = BASE_URL + 'city';
export const Tags_API = BASE_URL + 'tags';
export const TOURS_API = BASE_URL + 'tours';
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiY2FzYmFoZGV2IiwiYSI6ImNsZzU0NGZ4eDAxaDgzbm90N3doeG9lMXYifQ.N92Svf7rjH1NSKgn2k-R2w';
export const MAPBOX_SATELLITE_STYLE_URL = 'mapbox://styles/mapbox/satellite-v9';
export const MAPBOX_DIRECTIONS_API = 'https://api.mapbox.com/directions/v5/';
export const MAPBOX_STYLE_URL =
  'mapbox://styles/casbahdev/clg55cs3r003401o6xkm7274p';
export const GEO_CODE_TOKEN = 'pk.65104f38330f39d384fcbd08bdca80ff';

export const ROUTING_PROFILES = ['driving', 'walking'];
export const POPULAR_SLUG = 'populaire';
export const REMOVE_FROM_FILTER_TAGS = [
  'balneaire',
  'activite-deal',
  'restaurant-deal',
  'sejour-deal',
  'hebergement-deal',
  'infos-pratiques',
  'evenement',
  'best-of',
  'enfants',
  'shopping',
  'eaux-vives',
  'evasion-montagnarde',
];
export const PREFERENCES_SLUGS = [
  'patrimoine',
  'cinema',
  'musee',
  'nature',
  'histoire',
  'culture',
];
export const COMMERCIAL_TAGS = [
  'gastronomie',
  'agences-de-voyage',
  'restaurant-deal',
  'restaurants',
  'sejour-deal',
  'hebergement-deal',
  'hebergement',
];

export const SEARCH_SLUGS = ['agences-de-voyage', 'hebergement', 'restaurants'];

export const STEPS_TAGS = ['all', 'see', 'do', 'eat'];
export const DO_TAGS = ['shopping', 'hebergement', 'agences-de-voyage'];

export const SEE_TAGS = [
  'nature',
  'patrimoine',
  'culture',
  'musee',
  'cinema',
  'artisanat',
];

export const EAT_TAGS = ['restaurants', 'gastronomie'];

export const socials = [
  {
    name: 'telegram',
    ShareButton: TelegramShareButton,
    Icon: TelegramIcon,
  },
  {
    name: 'linkedIn',
    ShareButton: LinkedinShareButton,
    Icon: LinkedinIcon,
  },
  {
    name: 'whatsapp',
    ShareButton: WhatsappShareButton,
    Icon: WhatsappIcon,
  },
  {
    name: 'email',
    ShareButton: EmailShareButton,
    Icon: EmailIcon,
  },
  {
    name: 'facebook',
    ShareButton: FacebookShareButton,
    Icon: FacebookIcon,
  },
  {
    name: 'twitter',
    ShareButton: TwitterShareButton,
    Icon: TwitterIcon,
  },
];
